// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"PageContainer_pageContainer__1zHHs","title":"PageContainer_title__YOYyZ"};